
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("j7fW8", function(module, exports) {
module.exports = JSON.parse('{"confluence-inline-reactions-mcu-nudge.description.many-reactions":"{count, plural, one {{user1}, {user2} und {count}\xa0weitere Person haben auf diese Seite reagiert} other {{user1}, {user2} und {count}\xa0weitere Personen haben auf diese Seite reagiert}}","confluence-inline-reactions-mcu-nudge.description.no-reactions":"Geben Sie die erste Reaktion ab.","confluence-inline-reactions-mcu-nudge.description.one-reaction":"{user} hat auf diese Seite reagiert","confluence-inline-reactions-mcu-nudge.description.two-reactions":"{user1} und {user2} haben auf diese Seite reagiert","confluence-inline-reactions-mcu-nudge.title":"Ihnen gef\xe4llt diese Seite? Lassen Sie es {authorName} wissen"}');

});


//# sourceMappingURL=de.93a23204.js.map
